import { useState } from "react";
import { Button } from "@/components/ui/PageHeader";
import { deregisterDeviceByPost, registerDevice, type DevicePlatform } from "@/api/notifications";

/** Register or drop a push token. Whether pushes are sent at all is `push` on GET /health. */
export function DevicesPanel() {
  const [token, setToken] = useState("");
  const [platform, setPlatform] = useState<DevicePlatform>("android");
  const [status, setStatus] = useState<string | null>(null);
  const run = async (label: string, step: () => Promise<unknown>) => {
    setStatus(null);
    try { await step(); setStatus(`${label}: done`); } catch (e) { setStatus(`${label}: ${e instanceof Error ? e.message : "failed"}`); }
  };
  const valid = token.trim().length >= 8;
  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-5">
      <h2 className="font-display text-lg font-semibold text-gray-900">Push devices</h2>
      <p className="mt-1 text-sm text-gray-600">An FCM registration token for this member. A new notification is pushed to the newest devices first.</p>
      <div className="mt-3 flex flex-wrap items-end gap-2 text-sm">
        <label className="grow">Token<input className="mt-1 block w-full rounded border p-2" value={token} maxLength={512}
          onChange={(event) => setToken(event.target.value)} /></label>
        <label>Platform<select className="mt-1 block rounded border p-2" value={platform}
          onChange={(event) => setPlatform(event.target.value as DevicePlatform)}>
          <option value="android">android</option><option value="ios">ios</option><option value="web">web</option>
        </select></label>
        <Button size="sm" disabled={!valid} onClick={() => run("Register", () => registerDevice(token.trim(), platform))}>Register</Button>
        <Button size="sm" variant="secondary" disabled={!valid} onClick={() => run("Drop", () => deregisterDeviceByPost(token.trim()))}>Drop</Button>
      </div>
      {status && <p className="mt-2 text-sm" role="status">{status}</p>}
    </section>
  );
}
